export default __webpack_public_path__ + "static/media/40859906-C5A5-4FFC-8CAC-B3184D94EFCC.1814be59.jpeg";